"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    shoppingCart: {
      actions: {
        addToCart: 'In den Warenkorb legen',
        buy: 'Kaufen',
        order: 'Bestellen',
        remove: 'Entfernen'
      },
      cart: {
        total: {
          label: 'Zusammen',
          helperText: '',
          helperTextPreview: ''
        },
        totalItems: {
          label: 'Insgesamt für Zeile',
          helperText: '',
          helperTextPreview: ''
        },
        totalShipping: {
          label: 'Insgesamt für Transport',
          helperText: '',
          helperTextPreview: ''
        },
        totalPayment: {
          label: 'Insgesamt für Zahlung',
          helperText: '',
          helperTextPreview: ''
        },
        totalTaxes: {
          label: 'Gesamtsteuer',
          helperText: '',
          helperTextPreview: ''
        },
        resetCart: 'Warenkorb zurücksetzen'
      },
      messages: {
        confirmResetCart: 'Möchten Sie den Inhalt des Warenkorbs wirklich löschen?',
        giftClaim: 'Sie können {quantity} Stück {productName} als Geschenk bekommen.',
        cartManipulations: {
          allRemoved: 'Alle Artikel wurden vom Warenkorb entfernt.',
          itemAdded: 'In den Warenkorb {number, plural, eine {byla pridaná položka} andere {byly pridany položky}}.',
          itemRemoved: 'vom Warenkorb {number, plural, eine {byla odstraněna položka} andere {byly odstraněny položky}}.',
          quantityChaged: 'Die gekaufte Menge hat sich geändert.'
        }
      },
      components: {
        appBartActionCart: 'Warenkorb',
        quantityField: {
          states: {
            quantityRounded: 'Die Menge wurde auf die nächste Verpackungseinheit gerundet.'
          }
        },
        cartAsidePreview: {
          cartEmpty: 'Ihr Warenkorb ist leer'
        },
        cartAfterAddModal: {
          continueShopping: 'mit dem Einkauf fortfahren',
          goToCart: 'Zum Warenkorb gehen',
          title: 'Produkte wurden in den Warenkorb gelegt',
          pcs: 'Stück'
        }
      }
    }
  }
};
var _default = messages;
exports.default = _default;